module.exports = __webpack_public_path__ + "static/media/modelS.cbb8bbfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modelS.jpg
// module id = 498
// module chunks = 33